import { Alert, Form, Input, Modal, Select, Spin } from 'antd';
import 'moment/locale/es';
import { useState } from 'react';
import { useAuth } from '../../../../../../store/AuthContext/AuthContext';
import { customRequest } from '../../../../../../common/request/customRequest';
import { STATUS_CODE } from '../../../../../../common/constants/statusCode';
import { PendingCredits } from '../../../../../components/design/credits/PendingCredits';
import { useIsAuthorized } from '../../../../common/roles/Roles';
import { DrawerPanelTitle, modalPanelStyles } from '../../../../common/Drawers/DrawerPanelTitle';

export const NewBenchmark = (props: {onClose: any, onFinish: any}) => {
	
	const [form] = Form.useForm();
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState(false);
	const { projectGroup } = useAuth();
	const numberOfCitiesValue = Form.useWatch('numberOfCities', form);
    const currentNeededCredits = 4 * numberOfCitiesValue;
	const isAuthorized = useIsAuthorized();

	const onFormFinish = async (values: any) => {
		
		const data = {
			...values
        };

		setIsLoading(true);
		const response = await customRequest(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/benchmark`, { method: 'POST', data: data });
		
		if (response?.statusCode === STATUS_CODE.BAD_REQUEST) {			
			setErrorMessage(response.message)			
		} else {
			props.onFinish();
		}
		setIsLoading(false);	
	}			 
	
	return (

		<Modal
			open={true}
			onOk={() => form.submit()}
			onCancel={props.onClose}
			afterClose={form.resetFields}
			{...modalPanelStyles}
			title={<DrawerPanelTitle title="Nuevo Benchmark" isProject={true} />}
		>
			<br/>
			<Form layout='vertical' form={form} onFinish={onFormFinish} initialValues={{distance:500, grid:2}}>

				<Form.Item label='Keyword' name='keyword' rules={[{ required: true }]}>
					<Input />
				</Form.Item>
														
				<Form.Item label='País' name='country' rules={[{ required: true }]}>
					<Select>
						<Select.Option value='España'>España</Select.Option>					
						<Select.Option value='Portugal'>Portugal</Select.Option>
					</Select>
				</Form.Item>				
				
				<Form.Item label='Número de ciudades a analizar' name='numberOfCities' rules={[{ required: true }]}>
					<Select>
						<Select.Option value='25'>TOP 25</Select.Option>					
						<Select.Option value='50'>Top 50</Select.Option>					
						<Select.Option value='100'>Top 100</Select.Option>					
						<Select.Option value='200'>Top 200</Select.Option>					
					</Select>
				</Form.Item>			
				{isAuthorized(['ROLE_ADMIN']) &&         
					<Form.Item label='Competidores' name='competitors'>
						<Input />
					</Form.Item>			
				}
			</Form>			
			{currentNeededCredits > 0 && <PendingCredits neededCredits={currentNeededCredits}/>}
			<br/>

			<div style={{display:'flex', justifyContent:'center'}}><Spin size='large' spinning={isLoading}/></div>
			{errorMessage && <b><Alert type='warning' showIcon={true} message='No hay créditos disponibles'/></b>}
		</Modal>
	)
}
